import * as yup from 'yup'

import { USAGE_AREA, LISTING_TYPE } from '@/modules/realestate/constants/realestate.const'

export const schemaLinkedService = yup.object({
  type: yup.string().required('Vui lòng chọn loại dịch vụ'),
  name: yup.string().required('Vui lòng nhập tên dịch vụ'),
  representative_name: yup.string().required('Vui lòng nhập tên người đại diện'),
  phone: yup.string().required('Vui lòng nhập số điện thoại'),
  email: yup.string().email('Email không hợp lệ').required('Vui lòng nhập email'),
  address: yup.string().required('Vui lòng nhập địa chỉ'),
  lat: yup.string().required('Vui lòng nhập vĩ độ'),
  lng: yup.string().required('Vui lòng nhập kinh độ'),
  description: yup.string().required('Vui lòng nhập mô tả'),
})

export const schemaCampaign = yup.object({
  package: yup.string().required('Vui lòng chọn gói'),
  activated_at: yup.string().required('Vui lòng chọn thời gian chiến dịch'),
  expired_at: yup.string().required('Vui lòng chọn thời gian chiến dịch'),
})
